/**
 * @fileoverview Confirm dialog validation.
 */

import type { ValidationResult, ConfirmValidationInput } from "./types";

const VALID_CONFIRM_VARIANTS = ["danger", "warning", "info"];

/**
 * Validate confirm dialog options.
 */
export function validateConfirm(
  options: ConfirmValidationInput,
): ValidationResult {
  const errors: string[] = [];

  // Title validation
  if (options.title === undefined || options.title === null) {
    errors.push("Confirm dialog title is required");
  } else if (typeof options.title !== "string") {
    errors.push("Confirm dialog title must be a string");
  } else if (options.title.trim() === "") {
    errors.push("Confirm dialog title cannot be empty");
  }

  // Message validation
  if (options.message === undefined || options.message === null) {
    errors.push("Confirm dialog message is required");
  } else if (typeof options.message !== "string") {
    errors.push("Confirm dialog message must be a string");
  } else if (options.message.trim() === "") {
    errors.push("Confirm dialog message cannot be empty");
  }

  // Confirm text validation (optional)
  if (options.confirmText !== undefined && options.confirmText !== null) {
    if (typeof options.confirmText !== "string") {
      errors.push("Confirm dialog confirmText must be a string");
    }
  }

  // Cancel text validation (optional)
  if (options.cancelText !== undefined && options.cancelText !== null) {
    if (typeof options.cancelText !== "string") {
      errors.push("Confirm dialog cancelText must be a string");
    }
  }

  // Variant validation (optional)
  if (options.variant !== undefined && options.variant !== null) {
    if (
      typeof options.variant !== "string" ||
      !VALID_CONFIRM_VARIANTS.includes(options.variant)
    ) {
      errors.push(
        `Invalid confirm variant "${options.variant}". Expected: ${VALID_CONFIRM_VARIANTS.join(" | ")}`,
      );
    }
  }

  return { valid: errors.length === 0, errors };
}
